import ComingSoon from "./components/comingsoon";
import './App.css';

function App() {
  return <ComingSoon />;
}

export default App;